export default {
  data() {
    return {
      searchTextCleaner: this.defaultSearchParams.search_cleaner || '',
      searchTextCleanerTimeout: null,
    };
  },
  watch: {
    searchTextCleaner(newVal) {
      clearTimeout(this.searchTextCleanerTimeout);
      this.searchTextCleanerTimeout = setTimeout(() => {
        this.searchParams.search_cleaner = newVal;
      }, 500);
    },
  },
};
